// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMobileAppFeedbackRequestDto
 */
export interface IMobileAppFeedbackRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IMobileAppFeedbackRequestDto
     */
    rate?: number;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppFeedbackRequestDto
     */
    feedback?: string;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppFeedbackRequestDto
     */
    feedback_type: IMobileAppFeedbackRequestDtoFeedbackTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppFeedbackRequestDto
     */
    app_version: string;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppFeedbackRequestDto
     */
    device_info: string;
}

/**
* @export
* @enum {string}
*/
export enum IMobileAppFeedbackRequestDtoFeedbackTypeEnum {
    RATED = 'RATED',
    RATED_WITH_NOTES = 'RATED_WITH_NOTES',
    NOT_RATED = 'NOT_RATED'
}


/**
 * Check if a given object implements the IMobileAppFeedbackRequestDto interface.
 */
export function instanceOfIMobileAppFeedbackRequestDto(value: object): value is IMobileAppFeedbackRequestDto {
    if (!('feedback_type' in value) || value['feedback_type'] === undefined) return false;
    if (!('app_version' in value) || value['app_version'] === undefined) return false;
    if (!('device_info' in value) || value['device_info'] === undefined) return false;
    return true;
}

export function IMobileAppFeedbackRequestDtoFromJSON(json: any): IMobileAppFeedbackRequestDto {
    return IMobileAppFeedbackRequestDtoFromJSONTyped(json, false);
}

export function IMobileAppFeedbackRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMobileAppFeedbackRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'rate': json['rate'] == null ? undefined : json['rate'],
        'feedback': json['feedback'] == null ? undefined : json['feedback'],
        'feedback_type': json['feedback_type'],
        'app_version': json['app_version'],
        'device_info': json['device_info'],
    };
}

export function IMobileAppFeedbackRequestDtoToJSON(json: any): IMobileAppFeedbackRequestDto {
    return IMobileAppFeedbackRequestDtoToJSONTyped(json, false);
}

export function IMobileAppFeedbackRequestDtoToJSONTyped(value?: IMobileAppFeedbackRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rate': value['rate'],
        'feedback': value['feedback'],
        'feedback_type': value['feedback_type'],
        'app_version': value['app_version'],
        'device_info': value['device_info'],
    };
}

